<kendo-dialog class="pedido-interno-dialog" [class.salvando]="salvando" width="100%" [maxWidth]="1280" height="100%"
              [animation]="false" autoFocusedElement="#interno-busca" (close)="feche()">
  <kendo-dialog-titlebar closeTitle="Fechar pedido interno">
    <div class="interno-cabecalho">
      <span class="interno-icone"><i class="far fa-clipboard" aria-hidden="true"></i></span>
      <div><h2>Pedido interno</h2><p>Solicite produtos para repor a vitrine.</p></div>
      <span class="interno-badge">Produção</span>
    </div>
  </kendo-dialog-titlebar>

  <div class="pedido-interno" [attr.aria-busy]="carregando || salvando">
    <div class="interno-erro" role="alert" *ngIf="erro">{{erro}}</div>
    <div class="interno-layout">
      <nav class="interno-categorias" aria-label="Categorias de produtos">
        <h3>Categorias</h3>
        <div class="interno-categorias-lista">
          <button type="button" [class.ativa]="categoriaSelecionada === null" [attr.aria-pressed]="categoriaSelecionada === null"
                  [disabled]="carregando || salvando" (click)="categoriaSelecionada = null">
            <span>Todos</span><small>{{produtos.length}}</small>
          </button>
          <button type="button" *ngFor="let categoria of categorias" [class.ativa]="categoriaSelecionada === categoria.nome"
                  [attr.aria-pressed]="categoriaSelecionada === categoria.nome" [disabled]="salvando"
                  (click)="categoriaSelecionada = categoria.nome">
            <span>{{categoria.nome}}</span><small>{{categoria.total}}</small>
          </button>
        </div>
      </nav>

      <section class="interno-catalogo" aria-label="Produtos para produzir">
        <div class="interno-catalogo-cabecalho">
          <div class="interno-busca">
            <i class="fas fa-search" aria-hidden="true"></i>
            <input id="interno-busca" type="search" placeholder="Buscar produto" aria-label="Buscar produto por nome ou código"
                   [(ngModel)]="busca" [disabled]="salvando">
          </div>
          <div class="interno-catalogo-titulo">
            <h3>{{categoriaSelecionada || 'Todos os produtos'}}</h3>
            <span>{{produtosFiltrados.length}} {{produtosFiltrados.length === 1 ? 'produto' : 'produtos'}}</span>
          </div>
        </div>
        <div class="interno-produtos" *ngIf="!carregando">
          <button type="button" class="interno-produto" *ngFor="let produto of produtosFiltrados"
                  [class.selecionado]="quantidadeProduto(produto) > 0" [disabled]="salvando" (click)="adicione(produto)"
                  [attr.aria-label]="'Adicionar ' + produto.nome">
            <div class="interno-produto-imagem">
              <img *ngIf="imagemProduto(produto); else produtoSemImagem" [src]="imagemProduto(produto)" alt="" loading="lazy"
                   (error)="imagemIndisponivel(produto)">
              <ng-template #produtoSemImagem><i class="fas fa-birthday-cake" aria-hidden="true"></i></ng-template>
            </div>
            <div class="interno-produto-info">
              <strong>{{produto.nome}}</strong>
              <div class="interno-produto-rodape">
                <span>Produção</span>
                <span class="interno-produto-quantidade" *ngIf="quantidadeProduto(produto) > 0">
                  {{quantidadeProduto(produto) | number:'1.0-3'}} {{unidadeProduto(produto)}}
                </span>
                <span class="interno-adicionar" aria-hidden="true">+</span>
              </div>
            </div>
          </button>
          <div class="interno-vazio" *ngIf="!produtosFiltrados.length">
            <i class="fas fa-search" aria-hidden="true"></i>
            <strong>{{produtos.length ? 'Nenhum produto encontrado' : 'Nenhum produto para produzir'}}</strong>
            <p>{{produtos.length ? 'Tente outra busca ou categoria.' : 'Configure o consumo dos ingredientes do produto como “Na produção” para solicitá-lo aqui.'}}</p>
          </div>
        </div>
        <div class="interno-vazio" role="status" *ngIf="carregando">Carregando produtos…</div>
      </section>

      <aside class="interno-resumo" aria-label="Resumo do pedido interno">
        <div class="interno-resumo-titulo">
          <h3>Itens do pedido</h3><span class="interno-badge">{{itens.length}} {{itens.length === 1 ? 'produto' : 'produtos'}}</span>
        </div>
        <div class="interno-resumo-conteudo">
          <div class="interno-vazio interno-carrinho-vazio" *ngIf="!itens.length">
            <i class="far fa-clipboard" aria-hidden="true"></i><strong>Seu pedido está vazio</strong>
            <p>Selecione os produtos que deseja produzir.</p>
          </div>
          <div class="interno-item" *ngFor="let item of itens">
            <div class="interno-item-linha">
              <div class="interno-item-imagem">
                <img *ngIf="imagemProduto(item.produto); else itemSemImagem" [src]="imagemProduto(item.produto)" alt=""
                     (error)="imagemIndisponivel(item.produto)">
                <ng-template #itemSemImagem><i class="fas fa-birthday-cake" aria-hidden="true"></i></ng-template>
              </div>
              <div class="interno-item-info">
                <strong>{{item.produto.nome}}</strong>
                <div class="interno-quantidade">
                  <button type="button" [disabled]="salvando || item.qtde <= 1" (click)="altereQuantidade(item, -1)"
                          [attr.aria-label]="'Diminuir quantidade de ' + item.produto.nome">−</button>
                  <input type="number" inputmode="decimal" min="0.001" step="any" [(ngModel)]="item.qtde" [disabled]="salvando"
                         [attr.aria-label]="'Quantidade de ' + item.produto.nome">
                  <button type="button" [disabled]="salvando" (click)="altereQuantidade(item, 1)"
                          [attr.aria-label]="'Aumentar quantidade de ' + item.produto.nome">+</button>
                  <span>{{unidadeProduto(item.produto)}}</span>
                </div>
              </div>
              <button type="button" class="interno-remover" [disabled]="salvando" (click)="remova(item)"
                      [attr.aria-label]="'Remover ' + item.produto.nome"><i class="far fa-trash-alt" aria-hidden="true"></i></button>
            </div>
            <button type="button" class="interno-observacao-acao" [disabled]="salvando"
                    [attr.aria-expanded]="!!item.exibirObservacao || !!item.observacao" (click)="item.exibirObservacao = !item.exibirObservacao">
              <i class="far fa-comment-alt" aria-hidden="true"></i>
              {{item.exibirObservacao || item.observacao ? 'Observação do item' : 'Adicionar observação'}}
            </button>
            <input *ngIf="item.exibirObservacao || item.observacao" class="interno-campo interno-observacao-item" type="text"
                   placeholder="Ex.: sem cobertura" [(ngModel)]="item.observacao" [disabled]="salvando"
                   [attr.aria-label]="'Observação de ' + item.produto.nome">
          </div>
          <div class="interno-detalhes">
            <div *ngIf="opcoes?.moduloComissionamentoAtivo">
              <label for="interno-responsavel">Responsável pela produção <span class="interno-obrigatorio">*</span></label>
              <select id="interno-responsavel" class="interno-campo" [(ngModel)]="comissionadoId" [disabled]="salvando" required>
                <option [ngValue]="null">Selecione o responsável</option>
                <option *ngFor="let pessoa of opcoes.comissionados" [ngValue]="pessoa.id">{{pessoa.nome}}</option>
              </select>
            </div>
            <div>
              <label for="interno-observacoes">Observações do pedido</label>
              <textarea id="interno-observacoes" rows="3" class="interno-campo" placeholder="Ex.: reposição da vitrine da tarde"
                        [(ngModel)]="observacoes" [disabled]="salvando"></textarea>
            </div>
          </div>
        </div>
        <div class="interno-total" *ngIf="itens.length"><strong>Total</strong><span>{{resumoQuantidades}}</span></div>
      </aside>
    </div>
  </div>

  <kendo-dialog-actions layout="end">
    <div class="interno-acoes">
      <p><i class="fas fa-info-circle" aria-hidden="true"></i>O pedido entra direto em preparação.</p>
      <button type="button" class="interno-cancelar" [disabled]="salvando" (click)="feche()">Cancelar</button>
      <button type="button" class="interno-enviar" [disabled]="carregando || salvando || !itens.length || !opcoes?.producaoPedidosAtiva"
              (click)="gere()"><i class="fas fa-arrow-right" aria-hidden="true"></i>{{salvando ? 'Enviando…' : 'Enviar para produção'}}</button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
